const storagePrefix = 'etebarBourse-admin-';
const clearPrefixedItems = storage => {
	for(let i = storage.length - 1; i >= 0; i--){
		const key = storage.key(i);
		if(key?.startsWith(storagePrefix))
			storage.removeItem(key);
	}
};

export const LocalStorage = {
	get: (key) => localStorage.getItem(storagePrefix + key),
	set: (key, value) => localStorage.setItem(storagePrefix + key, value),
	remove: (key) => localStorage.removeItem(storagePrefix + key),
	clear: () => {
		clearPrefixedItems(localStorage);
		clearPrefixedItems(sessionStorage);
	}
}
